import { Button, Modal, Space, InputNumber } from "antd";
import React, { useState } from "react";
import { EditFilled } from "@ant-design/icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const initialState = null;

export const ReliefPopup = (props) => {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [meters, setMeters] = useState(initialState);
   const [runningMeters, setRunningMeters] = useState(initialState);
   const [timePerMin, setTimePerMin] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setMeters(props.meters);
      setRunningMeters(props.runningMeters);
      setTimePerMin(props.timePerMin);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setMeters(initialState);
      setRunningMeters(initialState);
      setTimePerMin(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "relief", props.id);
      await updateDoc(ref, {
         meters: meters,
         runningMeters: runningMeters,
         timePerMin: timePerMin,
         id: props.id,
      })
         .then(() => {
            setIsModalOpen(true);
            setMeters(initialState);
            setRunningMeters(initialState);
            setTimePerMin(initialState);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };
   return (
      <>
         <Button size="small" type="primary" onClick={showModal}>
            <EditFilled />
         </Button>
         <Modal width={700} title="Relief Settings" open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space>
               <InputNumber addonBefore="Costs :" value={meters} style={{ width: "100%" }} onChange={(value) => setMeters(value)} />
               <InputNumber addonBefore="Speed :" value={runningMeters} style={{ width: "100%" }} onChange={(value) => setRunningMeters(value)} />
               <InputNumber addonBefore="ALSM :" value={timePerMin} style={{ width: "100%" }} onChange={(value) => setTimePerMin(value)} />
            </Space>
         </Modal>
      </>
   );
};
